// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__HOyxe","cta__title":"Cta_cta__title__2FjRv","cta__btn":"Cta_cta__btn__2hsRT"};